import { computed, ref, Ref, watch } from "vue";
import { GenericField } from "@/business/shared/commons/validator/validatorsTypes";
import { RequiredRule } from "@/business/shared/commons/validator/rules/RequiredRule";
import { validator } from "@/business/shared/commons/validator/validator";

export function createEditSampleValidator() {
  const reference: Ref<GenericField> = ref({
    enabled: false,
    errors: [],
    isSuccess: true,
    val: "",
    rules: [new RequiredRule("La referencia es obligatoria")],
  });
  const description: Ref<GenericField> = ref({
    enabled: false,
    errors: [],
    isSuccess: true,
    val: "",
    rules: [new RequiredRule("La descripción obligatoria")],
  });

  watch(
    () => reference.value.val,
    () => {
      if ((reference.value.val?.length ?? 0) > 0) {
        reference.value.enabled = true;
      }
    }
  );
  watch(
    () => description.value.val,
    () => {
      if ((description.value.val?.length ?? 0) > 0) {
        description.value.enabled = true;
      }
    }
  );

  function validate(field: GenericField, otherValue?: string): GenericField {
    return validator().validateField(field, otherValue);
  }

  const successForm = computed(() => {
    reference.value = validate(reference.value);
    description.value = validate(description.value);

    return !(
      reference.value.isSuccess &&
      description.value.isSuccess
    );
  });

  const successFormEdit = computed(() => {
    reference.value = validate(reference.value);
    description.value = validate(description.value);

    return !(
      reference.value.isSuccess &&
      description.value.isSuccess
    );
  });

  function reset(): void {
    reference.value.val = "";
    description.value.val = "";
    reference.value.enabled = false;
    description.value.enabled = false;
  }

  return {
    reference,
    description,
    successForm,
    successFormEdit,
    reset,
  };
}